import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/classroom.png'


const _hoisted_1 = { class: "relative flex flex-col w-full flex-1 items-center justify-center p-8 pt-32 lg:py-32 bg-gradient-to-bl from-neutral-900 via-neutral-900 to-black" }
const _hoisted_2 = ["alt"]

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AirdropPreview',
  props: ["image", "alt"],
  setup(__props, { expose }) {



const video = ref<HTMLVideoElement>();

onMounted(() => {
    if (video.value) {
        video.value.playbackRate = 1.5;
    }
});

const play = function () {
    video.value?.play();
};

const pause = function () {
    video.value?.pause();
};

expose({ play, pause });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "relative block w-full object-contain rounded-xl",
      src: _imports_0,
      alt: __props.alt
    }, null, 8, _hoisted_2)
  ]))
}
}

})